import { Chip, Tooltip } from '@resiliatech/birdsong'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import { ChipContainer } from '../SelfServeWidgets.styled'
import { WidgetCategoryEnum } from './types'

type WidgetCategoryProps = {
  category: WidgetCategoryEnum
}

export const WidgetCategory = ({ category }: WidgetCategoryProps) => (
  <ChipContainer>
    {category === WidgetCategoryEnum.danger && (
      <Tooltip
        title='Use caution as this widget has the ability to impact a large number of users or organizations'
        placement='bottom'
      >
        <Chip
          icon={<WarningAmberOutlinedIcon />}
          text='Danger Zone'
          variant='error'
        />
      </Tooltip>
    )}
    {category === WidgetCategoryEnum.readOnly && (
      <Chip
        icon={<LibraryBooksOutlinedIcon />}
        text='Read-Only'
        variant='general'
      />
    )}
    {category === WidgetCategoryEnum.userSpecific && (
      <Tooltip
        title='This widget will perform operations for the current (logged in) user'
        placement='bottom'
      >
        <Chip
          icon={<PersonOutlineOutlinedIcon />}
          text='User-Specific'
          variant='warning'
        />
      </Tooltip>
    )}
  </ChipContainer>
)
